// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-7152e52e]{font-family:\"Nimbus\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400}.svg-inline[data-v-7152e52e]{display:block;position:relative}.svg-inline[data-v-7152e52e] svg{height:100%;left:0;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
